import { FC, useEffect } from 'react';

import SSRIcon from '@ingka/ssr-icon';
import deliveryTruckIcon from '@ingka/ssr-icon/paths/delivery-truck';
import drillIcon from '@ingka/ssr-icon/paths/drill';
import pencilIcon from '@ingka/ssr-icon/paths/pencil';
import personIcon from '@ingka/ssr-icon/paths/person';
import recyclingIcon from '@ingka/ssr-icon/paths/recycle';
import get from 'lodash.get';

import { ProductAreaNo } from '../../enums/ProductAreaNo';
import SalesItem from '../../interfaces/SalesItem';

import './OrderListItemImage.scss';

export const getIconByProductAreaNo = (productAreaNo: string) => {
  switch (productAreaNo) {
    case ProductAreaNo.Assembly:
    case ProductAreaNo.AssemblyAndInstallationAccommodation:
      return drillIcon;

    case ProductAreaNo.PlanningAndMeasurement:
      return pencilIcon;

    case ProductAreaNo.Delivery:
      return deliveryTruckIcon;

    case ProductAreaNo.RemovalAndRecycling:
      return recyclingIcon;

    case ProductAreaNo.Installation:
      return personIcon;
  }
  return null;
};

interface IOrderListItemImageProps {
  item: SalesItem;
}

const OrderListItemImage: FC<IOrderListItemImageProps> = ({
  item: {
    businessStructure: { productAreaNo, productAreaName },
    localisedCommunications,
  },
}) => {
  const localisedCommunication = localisedCommunications?.[0];
  const productImgHref =
    get(localisedCommunication, 'media[0].variants[2].href') ||
    get(localisedCommunication, 'media[0].variants[0].href');
  const productName = localisedCommunication?.productName || '';
  const icon = getIconByProductAreaNo(productAreaNo);

  useEffect(() => {
    if (!productImgHref && !icon) {
      console.warn(`Missing image for ${productAreaName} (${productAreaNo}).`);
    }
  }, [icon, productAreaName, productAreaNo, productImgHref]);

  const iconComponent = icon ? <SSRIcon paths={icon} /> : null;

  return (
    <div className="OrderListItemImage mr-50 flex justify-center items-center theme-dark-product-image-container">
      {productImgHref ? (
        <img src={productImgHref} alt={productName} className="w-full h-full" />
      ) : (
        iconComponent
      )}
    </div>
  );
};

export default OrderListItemImage;
